import { NationalIdentificationNumber, Passport } from '@dreryk/personal-external-identifier-common-api';

import { Pesel, TranslatableText, ValidationRules, WithFieldController } from '@dreryk/react-common';
import { StyledMaxWidth, TextInput } from '@dreryk/react-components';

import { PatientExternalIdentifierTypeVisitor } from './PatientExternalIdentifierTypeField';
import { translationKeys } from './translations';

export const patientExternalIdentifierValueDefaultValidationRules = (
   patientExternalIdentifierTypeVisitor: PatientExternalIdentifierTypeVisitor
): ValidationRules<{ patientExternalIdentifierValue: string | null }> =>
   patientExternalIdentifierTypeVisitor({
      visitPesel: () => ({
         required: true,
         maxLength: Pesel.PESEL_LENGTH,
         validate: (value) =>
            Pesel.isValid(value as string)
               ? undefined
               : translationKeys.patientExternalIdentifierValue.validate.invalidPesel,
      }),
      visitPassport: () => ({
         required: true,
         maxLength: Passport.MAX_LENGTH,
         pattern: {
            value: new RegExp(Passport.PATTERN, 'u'),
            message: translationKeys.patientExternalIdentifierValue.validate.invalidPassportPattern,
         },
         validate: (value) =>
            Passport.isValueValid(value as string)
               ? undefined
               : translationKeys.patientExternalIdentifierValue.validate.invalidPassport,
      }),
      visitNationalIdentificationNumber: () => ({
         required: true,
         maxLength: NationalIdentificationNumber.MAX_LENGTH,
         pattern: {
            value: new RegExp(NationalIdentificationNumber.PATTERN, 'u'),
            message: translationKeys.patientExternalIdentifierValue.validate.invalidNationalIdentificationNumberPattern,
         },
         validate: (value) =>
            NationalIdentificationNumber.isValueValid(value as string)
               ? undefined
               : translationKeys.patientExternalIdentifierValue.validate.invalidNationalIdentificationNumber,
      }),
   });

type PatientExternalIdentifierValueFieldProps = WithFieldController<unknown> & {
   readonly patientExternalIdentifierTypeVisitor: PatientExternalIdentifierTypeVisitor;
   readonly label?: TranslatableText;
};

export const PatientExternalIdentifierValueField = (props: PatientExternalIdentifierValueFieldProps): JSX.Element => (
   <StyledMaxWidth maxWidth={263}>
      <TextInput
         testId={'patientExternalIdentifierValue'}
         label={props.label || translationKeys.patientExternalIdentifierValue.label}
         placeholder={props.patientExternalIdentifierTypeVisitor(
            (type) => translationKeys.patientExternalIdentifierValue.placeholder[type]
         )}
         controller={props.controller}
         defaultValue={null}
      />
   </StyledMaxWidth>
);
